import {
	SCHOOL_ROLES_LIST,
	AGENT_ROLES_LIST,
	SYSTEM_ROLES_LIST
} from '@/config/constant';

export const username = state => state.userInfo.username;

export const menu = state => state.menu;

export const token = state => state.token;

export const role = state => state.userInfo.role;

export const uid = state => state.userInfo.uid;

export const roleId = state => state.userInfo.roleId;

export const nickname = state => state.userInfo.nickname;

export const schoolId = state => state.userInfo.schoolId;

export const staffId = state => state.userInfo.staffId;

export const menuCategory = state => state.menuCategory;

export const menuSort = state => state.menuSort;

export const level = state => {
	let userInfo = state.userInfo;
	if (SCHOOL_ROLES_LIST.includes(userInfo.role)) {
		return 3;
	} else if (AGENT_ROLES_LIST.includes(userInfo.role)) {
		return 2;
	} else if (SYSTEM_ROLES_LIST.includes(userInfo.role)) {
		return 1;
	} else {
		return 0;
	}
};
